import { Text, Box } from '@chakra-ui/react'
import { CustomEditableControls } from "./CustomEditableControls"
import { TinySelect } from './offers/grid/components/TinySelect'
import { PackageItemModel } from 'BrokerTsLib/src/dtos'
import { priceFormat } from 'BrokerTsLib/src/Utils/formatPrice'
import { createContext, useRef, useState } from 'react'
import { useHandleClickOutside } from '../hooks/useHandleClickOutside'

interface IEditableContext {
    isEditing: boolean,
    setIsEditing: (isEditing: boolean) => void
}

const defaultState: IEditableContext = {
    isEditing: false,
    setIsEditing: () => { }
}

export const EditableContext = createContext<IEditableContext>(defaultState)

type EditablePackageItemTinySelectProps = {
    packageItem: PackageItemModel
    limit?: number
    valueText?: string
    isDisabled?: boolean
    onSubmit: (value: number, id?: number) => void
    isEditing?: boolean
    showControls?: boolean
    packageItemVariantId?: number
}

export const EditablePackageItemTinySelect = ({ packageItem, limit, valueText, packageItemVariantId, onSubmit, isDisabled, isEditing: edditing = false, showControls = true }: EditablePackageItemTinySelectProps) => {
    const [isEditing, setIsEditing] = useState(edditing)

    const ref = useRef(null)
    useHandleClickOutside(ref, () => {
        setIsEditing(false)
    })

    let displayText = valueText
    if (limit == 0 && packageItem.variants?.length > 0) {
        // specialita - pokud je limit 0 ale varianta s limitem 0 neexistuje - zobrazit defaultni limit
        // nastává při prvním zobrazení nabídky, kdy se takto vygenerují offer party.
        if (packageItem.variants.findIndex(x => x.defaultLimit == 0) == -1) {
            const variant = packageItem.variants.find(x => x.isDefault) ?? packageItem.variants[0]
            displayText = priceFormat(variant.defaultLimit, null, '0 Kč')
        }
    }

    return (
        <EditableContext.Provider value={{
            isEditing: isEditing,
            setIsEditing: setIsEditing
        }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
                {!isEditing &&
                    <Text sx={{ p: 0, fontSize: 'sm', textDecoration: 'underline', textDecorationStyle: 'dotted' }}>{displayText}</Text>
                }
                {isEditing && <>
                    <TinySelect ref={ref}
                        isDisabled={isDisabled}
                        onChange={(e) => {
                            var dataset = e.target.options[e.target.selectedIndex].dataset
                            onSubmit(parseInt(dataset.limit!), parseInt(dataset.id!))
                            setIsEditing(false)
                        }}
                        value={(limit?.toString() ?? '') + '_' + (packageItemVariantId?.toString() ?? '')}
                    >
                        {packageItem.variants.map((option) => {
                            if ((!option.defaultLimit && option.defaultLimit != 0) || !option.id) return null

                            return (
                                <option key={option.defaultLimit + option.id} value={option.defaultLimit.toString() + '_' + option.id.toString()} data-id={option.id} data-limit={option.defaultLimit}>
                                    {option.limitText ? option.limitText : option.defaultLimit == 999999999 ? 'Neomezeně' : priceFormat(option.defaultLimit, null, '0 Kč')}
                                </option>

                            )
                        })}
                    </TinySelect>

                </>
                }

                {!isDisabled && showControls && <CustomEditableControls />}
            </Box>
        </EditableContext.Provider>
    )
}

type EditableTinySelectProps = {
    variants: {
        value: string,
        id: number
    }[],
    valueText?: string
    isDisabled?: boolean
    onSubmit: (value: string, id: number) => void
    isEditing?: boolean
    showControls?: boolean
    value: string
}

export const EditableTinySelect = ({ variants, value, valueText, onSubmit, isDisabled, isEditing: edditing = false, showControls = true }: EditableTinySelectProps) => {
    const [isEditing, setIsEditing] = useState(edditing)

    const ref = useRef(null)
    useHandleClickOutside(ref, () => {
        setIsEditing(false)
    })

    return (
        <EditableContext.Provider value={{
            isEditing: isEditing,
            setIsEditing: setIsEditing
        }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
                {!isEditing &&
                    <Text sx={{ p: 0, fontSize: 'sm', textDecoration: 'underline', textDecorationStyle: 'dotted' }}>{valueText}</Text>
                }
                {isEditing && <>
                    <TinySelect ref={ref}
                        isDisabled={isDisabled}
                        onChange={(e) => {
                            var dataset = e.target.options[e.target.selectedIndex].dataset
                            onSubmit(dataset.value!, parseInt(e.target.value))
                            setIsEditing(false)
                        }}
                        value={value}
                    >
                        {variants.map((option) => {
                            if (!option.value || !option.id) return null

                            return (
                                <option key={option.value} value={option.id.toString()} data-value={option.value}>
                                    {option.value}
                                </option>

                            )
                        })}
                    </TinySelect>
                </>
                }

                {!isDisabled && showControls && <CustomEditableControls />}
            </Box>
        </EditableContext.Provider>
    )
}